"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Entry.FieldTextDynamic = /*#__PURE__*/function (_Entry$Field) {
  function FieldTextDynamic(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldTextDynamic);
    _this = _callSuper(this, FieldTextDynamic, [content, blockView, index, null, null, true]);
    var fontSize = content.fontSize,
      _content$align = content.align,
      align = _content$align === void 0 ? 'left' : _content$align,
      text = content.text,
      color = content.color,
      setValue = content.setValue;
    _this._block = blockView.block;
    _this._blockView = blockView;
    _this._index = index;
    _this.box = new Entry.BoxModel();
    _this._font_size = fontSize || blockView.getSkeleton().fontSize || 12;
    _this._color = color || _this._block.getSchema().fontColor || blockView.getSkeleton().color || 'white';
    _this._align = align;
    _this._text = _this.getValue() || text;
    _this.textElement = null;
    _this.setGenerateValue = setValue;
    _this.renderStart(blockView);
    return _this;
  }
  (0, _inherits2["default"])(FieldTextDynamic, _Entry$Field);
  return (0, _createClass2["default"])(FieldTextDynamic, [{
    key: "_updateValue",
    value: function () {
      var _updateValue2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var value, reDraw;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.setGenerateValue) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.next = 2;
              return this.setGenerateValue();
            case 2:
              value = _context.sent;
              this._text = value;
              reDraw = this.value !== value;
              if (reDraw) {
                this.value = undefined;
              }
              this.setValue(value, reDraw);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _updateValue() {
        return _updateValue2.apply(this, arguments);
      }
      return _updateValue;
    }()
  }, {
    key: "renderStart",
    value: function renderStart() {
      var _this2 = this;
      var contentSvgGroup = this._blockView.contentSvgGroup;
      this._updateValue();
      if (!this.textElement) {
        this.svgGroup = this.textElement = contentSvgGroup.elem('text').attr({
          style: 'white-space: pre;',
          'font-size': "".concat(this._font_size, "px"),
          'font-weight': 'bold',
          'font-family': EntryStatic.fontFamily || 'NanumGothic',
          "class": 'dragNone',
          fill: this._color
        });
      }
      var old = this.textElement.textContent;
      // this._text = this._text.replace(/(\r\n|\n|\r)/gm, ' ');
      var text = this._text || '';
      if (old !== text.replace(/(\r\n|\n|\r)/gm, '')) {
        var textList = this._text.split(/\r\n|\n|\r/gm);
        textList.forEach(function (text, i) {
          _this2.textElement.elem('tspan').attr({
            dy: "".concat(i ? 14 : 0, "px")
          }).textContent = text;
        });
        this.textElement.textContent = this._text;
      }
      var _this$getTextBBox = this.getTextBBox(),
        width = _this$getTextBBox.width,
        height = _this$getTextBBox.height;
      var x = this._align == 'center' ? -width / 2 : 0;
      var offsetY = EntryStatic.fontOffsetY || 0;
      this.textElement.attr({
        x: x,
        y: height * 0.5 + offsetY
      });
      if (this.textElement.childElementCount > 1) {
        var childNodes = this.textElement.childNodes;
        for (var i = 0; i < childNodes.length; i++) {
          childNodes[i].attr({
            x: x
          });
        }
      }
      this.box.set({
        x: 0,
        y: 0,
        width: width,
        height: height
      });
    }
  }, {
    key: "getTextValue",
    value: function getTextValue() {
      return this._text;
    }
  }]);
}(Entry.Field);